import makeApiCall from "../master/axiosIndex";

const DashboardApis = {
  workOrderSummary: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/work-order-summary`,
    }),
  workOrderTotalsSummary: (params?: any) =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/work-order-totals-summary`,
      params,
    }),
  WorkOrderStatus: (params?: any) =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/work-order-status`,
      params,
    }),
  TopWorkCategories: (params?: any) =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/top-work-categories`,
      params,
    }),
  TopContractorsbyWorkOrders: (params?: any) =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/top-contractors`,
      params,
    }),
  BudgetVariancebyContractor: (params?: any) =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/budget-variance-by-contractor`,
      params,
    }),
  WorkExecutionMonitoring: (params?: any) =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/work-execution-monitor`,
      params,
    }),
  PendingExecutionApprovals: (params?: any) =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/pending-execution-approvals`,
      params,
    }),
  ContractorSummary: (params?: any) =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/contract-summary`,
      params,
    }),
};

export default DashboardApis;
